import React, {Component} from 'react'
import confirmDialog from "../../../components/dialog/ConfirmDialog";
import ValidationUtil from "../../../components/form/validator/ValidationUtil";
import RemotingService from "../../../services/remoting-service/RemotingService";
import {Wizard} from "../../../components";
import SignatureInput from "../../../components/signature-input/SignatureInput";
import FormField from "../../../components/form/FormField";
import ClinicLogo from "../../../layout/ClinicLogo";
import {buildAttendanceHeader, buildAttendanceCptCodes, appointmentToSession}
    from "../../insurance/eligibility/v2/directbilling/attendanceFormUtil";
import "../../insurance/eligibility/v2/directbilling/DirectBillingAttendanceForm.css";

export default class PublicDirectBillingAttendanceForm extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    createHeader = () => {
        return <div style={{padding: "0px 20px 0px 20px"}}>
            <div className="row text-left">
                <div className="col-12 no-padding">
                    <ClinicLogo/>
                </div>
            </div>
            <div className="row">
                <div className="col-12 text-center no-padding" style={{fontSize: 20, fontWeight: "bold"}}>
                    ATTENDANCE &amp; TREATMENT RECORD
                </div>
            </div>
        </div>;
    };

    itemChanged = (item, signature) => {
        item.patientSignature = signature;
        this.forceUpdate();
    };

    close = () => {
        confirmDialog(
            'Confirmation',
            'Are you sure you want to close this form? All input will be lost.',
            this.props.close);
    };

    submitForm = () => {
        if (ValidationUtil.checkWithNotification(this.formFields)) {
            const {consentFormCode: code, form} = this.props;
            const directBillingId = form.directBilling?.id;
            // Send back the exact DTO the backend returned; each item's
            // patientSignature was already updated in place via itemChanged.
            RemotingService.postRemoteCall(
                `api/public/consent-form/code/${code}/direct-billing-attendance/${directBillingId}/update`,
                form);
            this.props.onFormSubmit(form);
        }
    };

    renderHeaderField(label, value, full = false) {
        return (
            <div className={`atr-field${full ? ' atr-field-full' : ''}`}>
                <label>{label}</label>
                <span className="atr-field-value">{value || ''}</span>
            </div>
        );
    }

    render() {
        this.formFields = [];
        const {form} = this.props;
        const header = buildAttendanceHeader(form.directBilling);
        const cptCodes = buildAttendanceCptCodes(form.directBilling?.items);
        const items = form.attendanceFormItems || [];

        return (
            <Wizard
                show={true} fullScreen
                footerStyle={{backgroundColor: '#f5f5f5'}}
                buttonStyle={{backgroundColor: '#84BE56', border: 'none'}}
                header={this.createHeader()}
                close={this.close}
                onSubmit={this.submitForm}>

                <Wizard.Page>
                    <div className="atr-printable" style={{margin: "20px"}}>
                        <div className="atr-header">
                            {this.renderHeaderField('Patient Name:', header.patientName)}
                            {this.renderHeaderField('DOB/Age:', header.dobAge)}
                            {this.renderHeaderField('MRN:', header.mrn)}
                            {this.renderHeaderField('Member ID:', header.memberId)}
                            {this.renderHeaderField('Insurance Provider:', header.insuranceProvider)}
                            {this.renderHeaderField('Authorization No.:', header.authorizationNo)}
                            {this.renderHeaderField('Diagnosis:', header.diagnosis, true)}
                            {this.renderHeaderField('Approved Sessions:', header.approvedSessions)}
                            {this.renderHeaderField('Approval Date:', header.approvalDate)}
                            {this.renderHeaderField('End Date:', header.endDate)}
                        </div>

                        <div style={{overflowX: "auto"}}>
                            <table className="atr-table atr-public">
                                <thead>
                                    <tr>
                                        <th style={{width: '42px'}}>Session</th>
                                        <th>Date</th>
                                        <th>Start Time</th>
                                        <th>End Time</th>
                                        <th>Total Duration (min)</th>
                                        <th>CPT Code(s)</th>
                                        <th>Patient Sign</th>
                                        <th>Provider Sign</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.length === 0 ? (
                                        <tr>
                                            <td colSpan={8} className="atr-empty-row">No sessions to sign</td>
                                        </tr>
                                    ) : items.map((item, index) => {
                                        const row = appointmentToSession(item.appointment || {}, cptCodes);
                                        const cptLines = (row.cptCodes || '').split('\n').filter(Boolean);
                                        return (
                                            <tr key={item.appointment?.id || index}>
                                                <td className="atr-session-no">{index + 1}</td>
                                                <td>{row.date}</td>
                                                <td>{row.startTime}</td>
                                                <td>{row.endTime}</td>
                                                <td>{row.totalDuration}</td>
                                                <td className="atr-cpt-cell">
                                                    {cptLines.map((line, i) => (
                                                        <div key={i} className="atr-cpt-line">{line}</div>
                                                    ))}
                                                </td>
                                                <td className="atr-patient-sign-cell">
                                                    <FormField ref={formField => this.formFields.push(formField)}
                                                               required requiredMessage="Signature required"
                                                               validateOn={item.patientSignature}>
                                                        <SignatureInput signature={item.patientSignature}
                                                                        onClear={() => this.itemChanged(item, null)}
                                                                        onSave={(signature) => this.itemChanged(item, signature)}/>
                                                    </FormField>
                                                </td>
                                                <td>
                                                    {item.providerSignature &&
                                                        <img className="atr-sign-img"
                                                             src={`data:image/jpeg;base64,${item.providerSignature}`}
                                                             alt=""/>}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Wizard.Page>
            </Wizard>
        )
    }
}
